import { useEffect, useState } from "react";
import config from "../config";

export function useCategoriasTalles() {
  const [categorias, setCategorias] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCategorias = async () => {
      try {
        console.log('🔍 Intentando cargar categorías desde:', config.api.baseUrl);
        
        const response = await fetch(`${config.api.baseUrl}/categorias`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
        });

        console.log('📡 Response status:', response.status);

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        console.log('✅ Categorías cargadas:', data.length);
        
        setCategorias(data);
        setLoading(false);
      } catch (err) {
        console.error('❌ Error al cargar categorías:', err);
        setError(err.message || 'Error desconocido');
        setLoading(false);
      }
    };

    fetchCategorias();
  }, []);

  // Solo retorna datos, nunca JSX
  return { categorias, loading, error };
}